<template>
  <div class="gSwiperBox">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item, index) in adList" :key="index">
        <img :src="item.path" @click="linkTo(item)" :style="{ maxHeight: maxH }" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "gSwiper",
  props: {
    arr: {
      type: Array,
      default: [],
    },
    maxH: {
      type: String,
      default: "192px",
    },
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 0,
        loop: true,
        autoplay: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      contentList: [
        { id: 1, url: "" },
        { id: 2, url: "" },
        { id: 3, url: "" },
        { id: 4, url: "" },
      ],
      adList: [],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  async created() {
    if (this.arr.length) {
      this.adList = this.arr;
    }
  },
  methods: {
    linkTo(item) {
      if (this.isMobile()) {
        //  <a href="weixin://dl/business/?appid=wx1c4e19e5871a548c#wechat_redirect"
        // >跳转到微信小程序</a>
        window.location.href = "https://cdn.indata3.com/apichina/index.html";

        console.log("手机端");
      } else {
        console.log("pc端");
        window.open("https://www.apichina.com.cn/#/");
      }

      //   if (item.link) {
      //     window.open(item.link);
      //   }
    },

    // 判断是否是手机端，如果是，返回true
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style lang="scss">
.swiper-slide {
  img {
    width: 100%;
    max-height: 192px;
  }
}
.gSwiperBox .swiper-container {
  font-size: 0;
}
.gSwiperBox .swiper-pagination {
  font-size: 0;
  display: flex;
  justify-content: flex-end;
  padding-right: 18px;
  bottom: 22px;
  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    border-radius: 0;
    background-color: #dddddd;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    background-color: #ed6e02;
    opacity: 1;
  }
}
</style>
